import { EmailThreadType } from '@shared/enums/email-thread-type.enum';

export { EmailThreadType };

export enum EmailThreadStatus {
  Block = 0,
  Allow = 1
}

export interface EmailThread {
  supplierUuid: string;
  type?: EmailThreadType;
  threadId: string;
  messageId?: string | null;
  recordGenerator?: string | null;
  enquiryUuid?: string;
  listingUuid?: string;
  status?: EmailThreadStatus;
  emailProvider?: string;
  isUnread?: boolean;
  created?: string;
  updated?: string;
}

export interface EmailThreadList {
  data: EmailThread[];
  total?: number;
}
